import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import { ArrowRight, Clock } from "lucide-react";

const posts = [
  { title: "5 verses to design your first faith tee around", date: "July 8, 2025", read: "4 min", excerpt: "If you're new to designing your own Scripture apparel, these five verses are the ones we come back to again and again.", tag: "Design" },
  { title: "How we prep artwork for a 100-shirt church order", date: "June 22, 2025", read: "6 min", excerpt: "A behind-the-scenes look at how we handle logos, sizes and print consistency for larger group orders.", tag: "Process" },
  { title: "Why every proof goes through a human first", date: "June 10, 2025", read: "3 min", excerpt: "Automated proofs miss the small stuff. Here's why we still review every design by hand before we print.", tag: "Quality" },
  { title: "Gifting a faith box: a small guide", date: "May 30, 2025", read: "5 min", excerpt: "Building a custom gift box for a friend walking through a hard season? A few suggestions from the shop.", tag: "Gifting" },
];

export default function Blog() {
  return (
    <PageShell kicker="Blog" title="Notes from the studio" subtitle="Design tips, behind-the-scenes and the occasional verse we can't stop thinking about.">
      <section className="max-w-6xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {posts.map((p) => (
          <article key={p.title} className="bg-white rounded-2xl border border-[color:var(--dms-navy)]/10 p-7 hover-lift">
            <span className="inline-block text-[10px] tracking-widest uppercase font-semibold text-[color:var(--dms-peach)] bg-[color:var(--dms-peach-light)]/40 px-3 py-1 rounded-full">{p.tag}</span>
            <h2 className="font-serif text-2xl text-[color:var(--dms-navy)] mt-4 leading-snug">{p.title}</h2>
            <p className="mt-3 text-[color:var(--dms-navy)]/70 text-sm leading-relaxed">{p.excerpt}</p>
            <div className="mt-5 flex items-center justify-between text-xs text-[color:var(--dms-navy)]/55">
              <span>{p.date}</span>
              <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {p.read}</span>
            </div>
            <Link to="/blog" className="link-peach mt-5 inline-flex text-[11px]">Read more <ArrowRight className="w-3.5 h-3.5" /></Link>
          </article>
        ))}
      </section>
    </PageShell>
  );
}
